import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'pennant', 'Pennant', [["path",{"d":"M8 21l4 0"}],["path",{"d":"M10 21l0 -18"}],["path",{"d":"M10 4l9 4l-9 4"}]]);